import { FormFieldRenderer } from '@/components/features/FormFieldRenderer/FormFieldRenderer';

import type { CreateSectionPayload, FormMode } from '@/types/form';
import type { FormField } from '@/types/form';

import styles from './BuilderPreview.module.css';

interface BuilderPreviewProps {
    title: string;
    description: string;
    sections: CreateSectionPayload[];
    mode: FormMode;
    themeColor: string;
}

function toFormField(field: CreateSectionPayload['fields'][0], id: number): FormField {
    return {
        id,
        label: field.label || `Pregunta ${id + 1}`,
        description: field.description ?? '',
        field_type: field.field_type,
        is_required: field.is_required,
        order: field.order,
        config: field.config,
        points: field.points ?? 0,
        correct_answer: field.correct_answer ?? {},
        shuffle_choices: field.shuffle_choices ?? false,
        conditional_rules: [],
        section_id: null,
    };
}

export function BuilderPreview({ title, description, sections, mode, themeColor }: BuilderPreviewProps) {
    const allFields = sections.flatMap((s) => s.fields);

    return (
        <div className={styles.preview}>
            <div className={styles.deviceFrame}>
                {/* Form header */}
                <div
                    className={styles.formHeader}
                    style={themeColor ? { borderTopColor: themeColor } : undefined}
                >
                    <h2 className={styles.formTitle}>{title || 'Sin titulo'}</h2>
                    {description && <p className={styles.formDesc}>{description}</p>}
                    {mode === 'quiz' && (
                        <span className={styles.quizBadge}>Quiz</span>
                    )}
                </div>

                {/* Fields preview */}
                <div className={styles.fieldsList}>
                    {allFields.length === 0 ? (
                        <p className={styles.empty}>Agrega preguntas para ver la vista previa</p>
                    ) : (
                        allFields.map((field, i) => (
                            <div key={i} className={styles.fieldCard}>
                                <FormFieldRenderer
                                    field={toFormField(field, i)}
                                    value=""
                                    setValue={() => {}}
                                />
                            </div>
                        ))
                    )}
                </div>

                {allFields.length > 0 && (
                    <button type="button" className={styles.submitPreview} disabled>
                        Enviar respuesta
                    </button>
                )}
            </div>
        </div>
    );
}
